import Event from '../../classes/event';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

function goToWatchEverything(asset?: Event) {
  const { media } = store.getState();
  if (asset?.channel?.name) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.WATCH_EVERYTHING },
        params: {
          current: { channelName: asset?.channel.name },
          push: true,
          stack: { position: !media.live ? media.currentTime : undefined },
        },
      })
    );
  }
}

export default goToWatchEverything;
